import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class housekeepingOptInStore {

    // Properties

    @observable housekeepingOptIn = undefined;
    @observable housekeepingOptInLoading = false;

    // Initialization

    @action initHousekeepingOptIn() {
        this.housekeepingOptInLoading = true;
        const roomNo = JSON.parse(window.localStorage.getItem('roomNo'));
        const customerId = window.localStorage.getItem('customerId');

        return ApiCaller.HousekeepingOptIns.apiGetHousekeepingOptInByRoomNumberAndGuestId(roomNo, parseInt(customerId)).then((housekeepingOptInResponse) => {
            if (housekeepingOptInResponse) {
                this.housekeepingOptIn = housekeepingOptInResponse;
            } else {
                this.housekeepingOptIn = undefined;
            }

            this.housekeepingOptInLoading = false;
        })
    }

    // Update

    @action updateHousekeepingOptIn() {
        this.housekeepingOptInLoading = true;
        return ApiCaller.HousekeepingOptIns.apiUpdateHousekeepingOptIn(this.housekeepingOptIn.houseKeepingOptInId, this.housekeepingOptIn).then((housekeepingOptInResponse) => {
            this.initHousekeepingOptIn();
        })
    }

    // Set Properties

    @action setHousekeepintOptInIsSunday(value) {
        this.housekeepingOptIn.isSunday = value;
    }

    @action setHousekeepintOptInIsMonday(value) {
        this.housekeepingOptIn.isMonday = value;
    }

    @action setHousekeepintOptInIsTuesday(value) {
        this.housekeepingOptIn.isTuesday = value;
    }

    @action setHousekeepintOptInIsWednesday(value) {
        this.housekeepingOptIn.isWednesday = value;
    }

    @action setHousekeepintOptInIsThursday(value) {
        this.housekeepingOptIn.isThursday = value;
    }

    @action setHousekeepintOptInIsFriday(value) {
        this.housekeepingOptIn.isFriday = value;
    }

    @action setHousekeepintOptInIsSaturday(value) {
        this.housekeepingOptIn.isSaturday = value;
    }
}

export default new housekeepingOptInStore()